// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"fecc1dd2","908":"cf87749b","918":"60ec8734"}[chunkId] + ".chunk.js";
};